var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from "react";
import "../../stylesheets/components/generic/footer/footerfeedbackpop.scss";
import { extractFileExtention } from "@frameworks/salesjourney/utils/regex";
import "../../stylesheets/components/generic/footer/footerfeedbackpop.scss";
export var FileUploadSection = function (props) {
    var _a = __read(useState(false), 2), docUploaded = _a[0], setDocUploaded = _a[1];
    var _b = __read(useState(false), 2), fileError = _b[0], setFileError = _b[1];
    var _c = __read(useState(false), 2), fileTypeError = _c[0], setFileTypeError = _c[1];
    var _d = __read(useState(""), 2), docFile = _d[0], setDocFile = _d[1];
    useEffect(function () {
        if (props.reset)
            resetForm();
    }, [props.reset]);
    useEffect(function () {
        if (props.fileName) {
            setDocUploaded(true);
            setDocFile(props.fileName);
        }
    }, []);
    var resetForm = function () {
        setDocUploaded(false);
        setDocFile("");
        setFileError(false);
        setFileTypeError(false);
    };
    var onSelectFile = function (e) {
        uploadFile(e.target.files[0]);
    };
    var uploadFile = function (file) {
        resetForm();
        if (file) {
            var extension = extractFileExtention.exec(file.name);
            if (!props.fileType.find(function (val) { return extension[1].toLowerCase() === val; })) {
                setFileTypeError(true);
                return;
            }
        }
        if (fileError)
            setFileError(false);
        setDocFile(file.name);
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setDocUploaded(true);
            props.onSubmit({
                base64Data: reader.result,
                docFile: file.name,
                docFileSize: file.size,
            });
            // resetForm();
        };
    };
    var removeUploadFile = function () {
        if (docFile) {
            setDocFile("");
            props.onSubmit({
                base64Data: "",
                docFile: "",
                docFileSize: 0,
            });
        }
        resetForm();
    };
    var dropHandler = function (e) {
        e.preventDefault();
        if (e.dataTransfer.items) {
            for (var i = 0; i < e.dataTransfer.items.length; i++) {
                if (e.dataTransfer.items[i].kind === "file") {
                    uploadFile(e.dataTransfer.items[i].getAsFile());
                }
            }
        }
    };
    return (React.createElement(React.Fragment, null,
        !docUploaded && (React.createElement("label", { className: "uploadWrap cursor", onDrop: dropHandler, onDragOver: function (e) { return e.preventDefault(); }, onDragEnter: function (e) { return e.preventDefault(); } },
            React.createElement("input", { type: "file", onChange: onSelectFile, className: "display-none", id: props.id ? props.id : "feedBackFile", onClick: function (e) { return (e.target.value = ""); } }),
            React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("label", { htmlFor: props.id ? props.id : "feedBackFile", id: "upload-icon", className: "edel-icon-upload-icon1 fs-20" })),
                React.createElement("div", null,
                    React.createElement("label", { htmlFor: props.id ? props.id : "feedBackFile", className: "upload-content" }, "Drag & drop your screenshot here or click here to upload"),
                    " ")))),
        fileTypeError && (React.createElement("div", null,
            React.createElement("p", { className: "uploadError" },
                "Please upload only ",
                "." + props.fileType.join(", ."),
                " files."))),
        docFile && (React.createElement("div", { className: "uploadSectionWrap" },
            React.createElement("div", { className: "fileNameSec" },
                React.createElement("div", { className: "uploaded-fileName" },
                    React.createElement("p", null, docFile)),
                React.createElement("div", { className: "uploaded-fileClose", onClick: removeUploadFile },
                    React.createElement("i", { className: "edel-icon-close" })))))));
};
